import React, { Component } from 'react'

import { MDBContainer, MDBRow, MDBCol, MDBBtn, MDBIcon, MDBInput, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter,  MDBBreadcrumb, MDBBreadcrumbItem } from 'mdbreact';
import { MDBNavbar, MDBNavbarBrand, MDBNavbarNav, MDBNavbarToggler, MDBCollapse, MDBNavItem, MDBNavLink, MDBMask, MDBView, MDBJumbotron, MDBBox } from 'mdbreact';
import { MDBTable, MDBTableBody, MDBTableHead,  } from 'mdbreact';
import { Form, Input, Button, Checkbox, message, Select } from 'antd';
//import Login from './Login';
import Axios from 'axios'
import { URL } from '../../api';
import logo from '../img/logokpru.png'
import FadeIn from 'react-fade-in';
import p1 from '../img/1656587759_2-illustration_png.png'
import p2 from '../img/1656587759_4-illustration_png.png'
import p3 from '../img/1656587761_12-illustration_png.png'
import Iframe from 'react-iframe'
import { api } from '../../api';
import { format } from "date-fns";
import { HorizontalBar } from 'react-chartjs-2';


import Swal from 'sweetalert2'
import {
  MDBTypography,
  MDBCard,
  MDBCardBody,
  MDBCardImage,
  MDBCardTitle,
  MDBCardText
} from 'mdbreact';

var xlsx = require("xlsx");


export default class Updatedataall extends Component {


  constructor(props) {
    super(props);
    this.state = {
      value: '',
      Psaaword: '',
      modal: false,
      collapse: false,
      isWideEnough: false,
      datastuKamphaengphet:[],
      team: '',
      load: false,

    };
    this.handleChange = this.handleChange.bind(this);
    this.handleChange2 = this.handleChange2.bind(this);
    this.toggle = this.toggle.bind(this);
    this.onClick = this.onClick.bind(this);
    this.onClick2 = this.onClick2.bind(this);
    this.readUploadFile = this.readUploadFile.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.onChangetype = this.onChangetype.bind(this);
    this.onChangetype2 = this.onChangetype2.bind(this);
    this.updateregister = this.updateregister.bind(this);
    this.getdataa = this.getdataa.bind(this);

  }


  updateregister(event,event2) {
   

     console.log(event )
     console.log(event2 )
   //  console.log(b.target.value)

    api.get(event2)
    .then((res) => {
      
      if (res.data !== null) {
                Swal.fire({
                title: 'อัพเดทข้อมูลสำเร็จ',
                icon: 'success',
            // showCancelButton: true,
                confirmButtonText: 'ตกลง',
            // cancelButtonText: 'No, keep it'
            }).then((result) => {
                                const  now = new Date();
                                const wanwela = new Date(now)
                                const formattedDate = format(wanwela, "yyyy-MM-dd");

                                const datafrm = new FormData(); 
                                datafrm.append("id", event);
                                datafrm.append("date", formattedDate);
                                    api.post("index/Updatelistupdate/",datafrm,{
                                        headers: {
                                            'content-type': 'multipart/form-data'
                                        }
                                    })
                                    .then(res => {
                                        if (res.status === 200) {
                                                    Swal.fire({
                                                        title: 'อัพเดทวันสำเร็จ',
                                                        icon: 'success',
                                                        // showCancelButton: true,
                                                        confirmButtonText: 'ตกลง',
                                                        // cancelButtonText: 'No, keep it'
                                                        }).then((result) => {
                                                            this.getdataa()
                                                        })
                                        }
                                    })   


            })
      }
    })
  
  
    }


  onChangetype(value) {
    this.setState({ team:value.target.value})
  // console.log(value.target.value)
  
  // Axios.get('https://e-student.kpru.ac.th/webgeduate2563/api/total/major-all/2/0/'+value.target.value)
  // .then((res) => {
  //      console.log(res.data.data1)
  //    this.setState({ datastuKamphaengphet: res.data })
  // })


  }

  onChangetype2(value) {
  //  this.setState({ team:value.target.value})
  // console.log(value.target.value)
  
  Axios.get('https://e-student.kpru.ac.th/webgeduate2563/api/total/major-all/2/0/'+this.state.team+'/'+value.target.value)
  .then((res) => {
       console.log(res.data.data1)
     this.setState({ datastuKamphaengphet: res.data })
  })


  }


  handleSubmit() {
    // alert('A name was submitted: ' + this.state.value);
//https://research.kpru.ac.th/research_new/Administrator_ResearchPublish/getpublic
    for (let index = 0; index < this.state.datastuKamphaengphet.length; index++) {

      const datafrm = new FormData(); 
      datafrm.append("team", this.state.team);
      datafrm.append("fuc_mua", this.state.datastuKamphaengphet[index].fuc_mua);
      datafrm.append("faculty_name", this.state.datastuKamphaengphet[index].faculty_name);
      datafrm.append("t_mjname", this.state.datastuKamphaengphet[index].t_mjname);
      datafrm.append("CountFinish", this.state.datastuKamphaengphet[index].CountFinish);
      datafrm.append("CountQuestionnaire", this.state.datastuKamphaengphet[index].CountQuestionnaire);
      datafrm.append("PrecentQuestionnaire", this.state.datastuKamphaengphet[index].PrecentQuestionnaire);
      datafrm.append("MajorCode", this.state.datastuKamphaengphet[index].MajorCode);
     
   

          api.post("index/AddNumfinsh/",datafrm,{
              headers: {
                  'content-type': 'multipart/form-data'
              }
            })

            
          .then(res => {
                if (res.status === 200) {
                 
                      if (this.state.datastuKamphaengphet.length === index+1) {
                        
                          Swal.fire({
                                title: 'นำเข้าข้อมูลสำเร็จ',
                                icon: 'success',
                              // showCancelButton: true,
                                confirmButtonText: 'ตกลง',
                              // cancelButtonText: 'No, keep it'
                              }).then((result) => {
                              
                              })
                      }
                }
          })   
  }

        
  }


  getdataa() {
    api.get('index/selectlistupdate')
    .then((res) => {
         console.log(res.data.data1)
       this.setState({ datastuKamphaengphet: res.data })
    })
  }

  componentDidMount() {


    this.getdataa()
    // fetch('https://portal.bopp-obec.info/obec64/restpublicstat/download/area/2564-2-schoolmis-00620001.json', {
    //     method: 'GET',
    //     body: JSON.stringify(),
    //     headers: {
    //     }
    //   })
    //     .then(res => res.json())
    //     .then((res) => {
    //         this.setState({ datastuKamphaengphet: res })
    //     })
    //     .catch(err => {
    //       console.log('request failed', err);
    //     })

    // api.get('index/selectlistupdate')
    // .then((res) => {
    //      console.log(res.data.data1)
    //    this.setState({ datastuKamphaengphet: res.data })
    // })


  }

 onClick2() {
     console.log('dd')
          Axios.get('https://portal.bopp-obec.info/obec64/restpublicstat/download/area/2564-2-schoolmis-00620001.json')
         .then((res) => {
      //  console.log(res.data)
       
        this.setState({ datastuKamphaengphet: res })
    })

  }



  onClick() {
    this.setState({
      collapse: !this.state.collapse,
    });
  }


  toggle = () => {
    this.setState({
      modal: !this.state.modal
    });
  }

  handleChange(event) { this.setState({ value: event.target.value }); }
  handleChange2(event) { this.setState({ Psaaword: event.target.value }); }


  update = () => {
    this.setState({
      name: "",
      lname: ""
    })
  }

  readUploadFile = (e) => {
    e.preventDefault();
    if (e.target.files) {
        const reader = new FileReader();
        reader.onload = (e) => {
            const data = e.target.result;
            const workbook = xlsx.read(data, { type: "array" });
            const sheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[sheetName];
            const json = xlsx.utils.sheet_to_json(worksheet);
         //   console.log(json);
            this.setState({ datastuKamphaengphet: json })

        };
        reader.readAsArrayBuffer(e.target.files[0]);
    }
}


  render() {
    const dUrl = "https://portal.bopp-obec.info/obec64/restpublicstat/download/area/2564-2-schoolmis-00620001.json";

  // console.log(dUrl);
  // console.log(this.props.location.pathname )
 //console.log('dd')

    return (

      <MDBContainer fluid>
       
        <MDBRow >
          <MDBCol md="12">
            <div>
              {/* <img src="https://research.kpru.ac.th/culture/LogoRDI.png" className="rounded mx-auto d-block w-50" alt="aligment" /><br/> */}
              {/* <img src={logo} className="rounded mx-auto d-block w-10 " alt="aligment" /><br/> */}
              <FadeIn>
              <MDBJumbotron className="p-4" fluid >
                 
                <MDBTypography blockquote bqColor='primary' className='h-0'>
                  <MDBIcon icon="user-injured" />   อัพเดทข้อมูลทั้งหมด
                </MDBTypography>
                {/* <MDBTypography note noteColor='primary' noteTitle='ด้านนักศึกษา '> </MDBTypography> */}
                    <MDBBreadcrumb>
                        <MDBBreadcrumbItem>Home</MDBBreadcrumbItem>
                        <MDBBreadcrumbItem>สำหรับ Admin</MDBBreadcrumbItem>
                        <MDBBreadcrumbItem active>อัพเดทข้อมูลทั้งหมด</MDBBreadcrumbItem>
                    </MDBBreadcrumb>
             
                            {/* <br/> */}
                           
                            {/* <form>
    <label htmlFor="upload">Upload File</label><br/>
    <input
        type="file"
        name="upload"
        id="upload"
        onChange={this.readUploadFile}
    />
</form> */}
     {/* <div className="mb-2">
     <label htmlFor="upload">เลือกปีการศึกษา</label><br/>
        <select className="browser-default custom-select"  onChange={this.onChangetype}>
          <option>เลือกปีการศึกษา</option>
          <option value="2566">2566</option>
          <option value="2565">2565</option>
          <option value="2564">2564</option>
        </select>
     </div>

     <div className="mb-2">
     <label htmlFor="upload">เลือกคณะ</label><br/>
        <select className="browser-default custom-select"  onChange={this.onChangetype2}>
          <option>เลือกคณะ</option>
          <option value="1">คณะวิทยาศาสตร์และเทคโนโลยี</option>
          <option value="2">คณะครุศาสตร์</option>
          <option value="3">คณะมนุษยศาสตร์และสังคมศาสตร์</option>
          <option value="4">คณะวิทยาการจัดการ</option>
          <option value="5">คณะเทคโนโลยีอุตสาหกรรม</option>
          <option value="8">คณะพยาบาลศาสตร์</option>
        </select>
     </div> */}
       

        {/* <br/> */}


<p>ตัวอย่างข้อมูล {this.state.datastuKamphaengphet.length} รายการ</p>
  <MDBTable small style={{ border: "1px" }} border width="100%">
                            <MDBTableHead  >
                                <tr  >
                                    <th>ลำดับ</th>
                                    <th>รายละเอียดข้อมูล</th>
                                    <th>อัพเดทล่าสุด (ปี/เดือน/วัน)</th>
                                    <th>googlesheel</th>
                                    <th>จัดการ</th>
                                    
                                </tr>
                            </MDBTableHead>

                            <MDBTableBody>
                                {this.state.datastuKamphaengphet.map((data,index) => {
                                    const dd = data.iddata
                                    const dd2 = data.url
                                    return <tr>
                                        <td>{index+1} </td>
                                        <td>{data.dataname}</td>
                                        <td>{data.dateupdate}</td>
                                        <td>{data.googlesheel}</td>
                                        <td><MDBBtn color="primary" size='sm' onClick={() => this.updateregister(dd,dd2)} >อัพเดท</MDBBtn></td>
                                    </tr>
                                })}
                            </MDBTableBody>
                            {/* <MDBTableBody>
                                <tr>
                                <td>1</td>
                                <td>ข้อมูลผู้สมัคร(Registerinforeport)</td>
                                <td>Otto</td>
                                <td><MDBBtn color="primary" size='sm' onClick={this.updateregister} >อัพเดท</MDBBtn></td>
                                </tr>
                                <tr>
                                <td>2</td>
                                <td>Jacob</td>
                                <td>Thornton</td>
                                <td>@fat</td>
                                </tr>
                                <tr>
                                <td>3</td>
                                <td>Larry</td>
                                <td>the Bird</td>
                                <td>@twitter</td>
                                </tr>
                             </MDBTableBody> */}
                        </MDBTable>
{/* <div  className='text-center'>
     <MDBBtn color="primary" onClick={this.handleSubmit} >บันทึก</MDBBtn>
</div>
                      */}
<br/>
       
                ที่มา 
                {/* <MDBIcon icon="caret-left" /><a href='https://www.sesaokpp.go.th/cms-sesaokpp/'> บัณฑิต</a> */}
                    {/* <MDBIcon icon="caret-left" /><a href='https://portal.bopp-obec.info/obec64/publicstat/report'> ระบบสารสนเทศ สพม</a> */}
                {/* <MDBIcon icon="caret-left" /><a href='/'> จำนวนนักเรียนมัธยมแต่ละโรงเรียน</a>
               <div > <MDBIcon icon="caret-left"  /> จำนวนผู้เข้าชม</div> */}
              </MDBJumbotron>

       

              </FadeIn>
            </div>
          </MDBCol>
        </MDBRow>

      </MDBContainer>


    )
  }
}
